import React from 'react'
import { useDispatch } from 'react-redux'
import { useRouter } from 'next/router'

import useTranslate from 'hooks/useTranslate'
import _ from 'lodash'
import H1 from 'components/Typography/H1'
import { ContentBlock, HeaderBlock } from 'components/Blocks'
import Intro from 'components/Typography/Intro'
import Link from 'components/Link'
import UserRegisterForm from 'components/Forms/UserRegisterForm'

import { actions as newReportActions } from 'store/modules/newReport'
import { actions as tempUserDetailsActions } from '../store/modules/tempUserDetails'
import { actions as authActions } from 'store/modules/auth'
import { actions as orgDetailsActions } from '../store/modules/organisationDetails'

import { useHCPProfessions, usePublicProfessions, useProfessions } from '../hooks/organisationDetailsHooks'
import { useFormConfig } from '../hooks/newReportHooks'
import { useWebsiteConfig } from '../hooks/configHooks'

const AboutYou = () => {
  const dispatch = useDispatch()
  const translate = useTranslate()
  const publicProfessions = usePublicProfessions()
  const hcpProfessions = useHCPProfessions()
  const orgProfessions = useProfessions()
  const websiteConfig = useWebsiteConfig()
  const continueWithoutRegistering = _.get(websiteConfig, 'continueWithoutRegistering')
  const router = useRouter()
  const reportId = router && router.query.reportId
  const formConfig = useFormConfig({ reportId })

  const onSubmit = React.useCallback((values) => {
    dispatch(newReportActions.updateFormConfig({
      reportId,
      values: {
        reportId: values.occupation === 'hcp'
          ? formConfig.healthcareProfessionalFormViewId
          : formConfig.memberOfPublicFormViewId
      }
    }))

    if (values.password) {
      return dispatch(authActions.register(values))
        .then(() => {
          router.push({
            pathname: '/new-report',
            query: {
              reportId
            }
          })
        })
    } else {
      const profession = _.find(orgProfessions, profession => profession.id === _.get(values, 'professionId'))
      const formInitialValues = {
        ..._.pick(values, [
          'title',
          'firstName',
          'lastName',
          'email',
          'professionId',
          'houseNumberOrName',
          'address',
          'addressLineTwo',
          'city',
          'county',
          'state',
          'postalCode',
          'telephoneCountryCode',
          'telephone',
          'telephoneExtension',
          'emailCommunicationsPermitted',
          'smsCommunicationsPermitted'
        ]),
        professionType: _.get(profession, 'type')
      }
      dispatch(tempUserDetailsActions.updateUserDetails({
        reportId,
        values: formInitialValues
      }))
      router.push({
        pathname: '/new-report',
        query: {
          reportId
        }
      })
    }
  }, [])

  React.useEffect(() => {
    dispatch(orgDetailsActions.fetchOrganisationDetails())
  }, [])

  return (
    <React.Fragment>
      <HeaderBlock>
        <H1>{translate('ABOUT_YOU_HEADING')}</H1>
        <Intro isSummary>{`${translate('ABOUT_YOU_SUBTITLE')}`} <Link href={`/sign-in?from=${encodeURIComponent(router.route)}&reportId=${reportId}`}>{translate('ABOUT_YOU_SUBTITLE_LINK')}</Link></Intro>
      </HeaderBlock>
      <ContentBlock>
        <UserRegisterForm
          onSubmit={onSubmit}
          variant={continueWithoutRegistering ? '' : 'register'}
          parseError={authActions.parseError}
          fieldOptions={{
            publicprofession: publicProfessions,
            profession: hcpProfessions
          }}
          reportId={reportId}
          buttonLabel={translate('BUTTON_LABEL_ABOUT_YOU_SUBMIT_AND_REGISTER')}
        />
      </ContentBlock>
    </React.Fragment>
  )
}

export default AboutYou
